// DS1.7.12
import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import TextTooltipOnHover from '../../Popover/Preset/TextTooltipOnHover';
import { useSubscriptionTier } from '../../utils/hooks/useSubscriptionTier';
import s from './TierStateBadges.scss';
var TierStateBadges = function (_a) {
    var _b, _c, _d, _e;
    var deviation = _a.deviation, showNeedCoreState = _a.showNeedCoreState, showPendingDeletionState = _a.showPendingDeletionState, className = _a.className;
    var t = useTranslation().t;
    var _f = useSubscriptionTier(deviation), isOwner = _f.isOwner, isUserSubscribed = _f.isUserSubscribed;
    var canPublish = (_b = deviation.tier) === null || _b === void 0 ? void 0 : _b.canUserPublish;
    var needCoreToPublish = isOwner && ((_c = deviation.tier) === null || _c === void 0 ? void 0 : _c.state) === 'draft' && !canPublish; // currently the only reason the owner cant publish
    var label;
    var tooltipText;
    var badgeClassName;
    if (((_d = deviation.tier) === null || _d === void 0 ? void 0 : _d.state) === 'draft') {
        tooltipText = t('deviationview.tierCard.stateBadge.tooltip.draft');
        label = t('deviationview.tierCard.stateBadge.label.draft');
        badgeClassName = 'draft';
    }
    else if (((_e = deviation.tier) === null || _e === void 0 ? void 0 : _e.state) === 'pending_deletion' &&
        showPendingDeletionState) {
        label = t('deviationview.tierCard.stateBadge.label.pendingDeletion');
        tooltipText = t('deviationview.tierCard.stateBadge.tooltip.pendingDeletion.visitor');
        if (isOwner) {
            tooltipText = t('deviationview.tierCard.stateBadge.tooltip.pendingDeletion.owner');
        }
        else if (isUserSubscribed) {
            tooltipText = t('deviationview.tierCard.stateBadge.tooltip.pendingDeletion.subscriber');
        }
        badgeClassName = 'pending-deletion';
    }
    if (!label) {
        // because typescript is not always smart enough
        return null;
    }
    return (React.createElement("div", { className: c(s['root'], className) },
        React.createElement(TextTooltipOnHover, { tooltipText: tooltipText },
            React.createElement("div", { className: c(s['badge'], s[badgeClassName]) }, label)),
        showNeedCoreState && needCoreToPublish && (React.createElement(TextTooltipOnHover, { tooltipText: t('deviationview.tierCard.stateBadge.tooltip.needCore') },
            React.createElement("div", { className: c(s['badge'], s['need-core']) }, t('deviationview.tierCard.stateBadge.label.needCore'))))));
};
TierStateBadges.displayName = 'TierStateBadges';
export default TierStateBadges;
//# sourceMappingURL=TierStateBadges.js.map